module.exports = __webpack_public_path__ + "static/MagicBunnySketch-b424421f0f9cfb2e3f8db92f2f2a1dd7.png";